import { useEffect, useState } from "react";
import useTalentApi from "components/Screens/Marketplace/Customer/TalentApiContext";
import { fetchCompanyTools } from "plg/api/plgCompany";

/**
 * The signed-in customer's own tools, matched against talent tools (prototype state.myTools). PLG customers
 * give them at sign-up and on the Company page; portal customers have none, so nothing is highlighted.
 */
export default function useCustomerTools(): string[] {
  const { kind } = useTalentApi();
  const [tools, setTools] = useState<string[]>([]);
  useEffect(() => {
    if (kind !== "plg") return undefined;
    let live = true;
    fetchCompanyTools().then((t) => live && setTools(t));
    return () => {
      live = false;
    };
  }, [kind]);
  return tools;
}
